import React, { useEffect, useRef } from 'react';
import { useInfiniteScroll } from '../../utils/useInfiniteScroll';

export const InfiniteScroll = ({
  loadMore,
  hasMore,
  children,
  loader,
  endMessage,
  threshold = 100,
  rootMargin = '100px',
  isReverse = false,
  className = '',
  ...props
}) => {
  const { sentinelRef, isLoading } = useInfiniteScroll(loadMore, {
    hasMore,
    threshold,
    rootMargin,
    isReverse,
  });

  return (
    <div 
      className={`infinite-scroll-container ${className}`} 
      style={{ display: 'flex', flexDirection: 'column' }}
      {...props}
    >
      {children}

      {/* Loading indicator - positioned at top for reverse scroll, bottom for normal */}
      {isLoading && loader && (
        <div 
          className="infinite-scroll-loader"
          style={{ order: isReverse ? -2 : 9998 }}
        >
          {loader}
        </div>
      )}

      {/* Sentinel element for intersection observer */}
      {hasMore && (
        <div
          ref={sentinelRef}
          className="infinite-scroll-sentinel"
          style={{
            height: '1px',
            width: '100%',
            // Position sentinel at top for reverse scroll, bottom for normal scroll
            order: isReverse ? -1 : 9999,
          }}
          aria-hidden="true"
        />
      )}

      {/* End message when no more content */}
      {!hasMore && endMessage && (
        <div 
          className="infinite-scroll-end-message"
          style={{ order: isReverse ? -3 : 9997 }}
        >
          {endMessage}
        </div>
      )}
    </div>
  );
};
